export const PRODUCT_SIZES = {
  S: 'S',
  M: 'M',
  L: 'L',
  XL: 'XL',
  SOLO: 'SOLO',
} as const;
export type ProductSize = typeof PRODUCT_SIZES[keyof typeof PRODUCT_SIZES];
